import { MathUtils, Vector3 } from 'three';

export const DIE_DRILL_AXIS = new Vector3(0.7, 0.55, 0.45).normalize();

// Shared by the Core and board enemies. Absolute time also supports skipped frames.
export const getDieDrillAngle = (elapsedMs, charge = 0, overclock = false) =>
  (Math.max(0, elapsedMs) / 1000) *
  (20 + MathUtils.clamp(charge, 0, 1) * 26) *
  (overclock ? 1.35 : 1);
